import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import WhiteLogo from '../../../images/logos/logo-white.svg';

const MobileLogo = () => (
  <StyledLink to="/">
    <WhiteLogo />
  </StyledLink>
);

const StyledLink = styled(Link)`
  display: flex;
`;

export default MobileLogo;
